export const ObjectTaxes = [
    {text: "01 - No objeto sin impuesto", value:"01"},
    {text: "02 - Sí objeto de impuesto", value:"02"},
    {text: "03 - Sí objeto del impuesto y no obligado al desglose", value:"03"},
    {text: "04 - Sí objeto del impuesto y no causa impuesto", value:"04"},
    {text: "05 - Si Objeto del Impuesto, IVA Crédito PODEBI", value:"05"},
    {text: "06 - Sí objeto del IVA, No traslado IVA", value:"06"},
    {text: "07 - No traslado del IVA, Si desglose IEPS", value:"07"},
    {text: "08 - No traslado del IVA, No desglose IEPS", value:"08"},
]